import { handleActions } from 'redux-actions';

export default handleActions(
	{
		GET_COLIVING: (state, action) => ({
			...state,

			list: action.payload.list,
			data: action.payload.data,
		}),
	},
	{
		list: [],
		data: {},
	},
);



// WEBPACK FOOTER //
// ./src/reducers/coLiving.js